module.exports = __webpack_public_path__ + "media/images/logo-red-a8ab55f37fd985d559efe9f30baed05f.png";